export default {
  logOut: 'LogOut',
  language: 'Language',
  modifyAdminPass: 'ModifyAdminPass',
  help: 'help',
  hi: 'hi，',
  logoutFailed: 'LogoutFailed',
  solution: 'Solution',
  smartHardware: 'SmartHardware',
  hardwareManage: 'HardwareManage',
  enterpriseInternalApp: 'EnterpriseInternalApp',
  weCode: 'WeCode',
  liteApp: 'LiteApp',
  thirdPartyApp: 'ThirdPartyApp',
  solutions: 'Solutions',
  appMarket: 'AppMarket',
  subscribeStatistics: 'SubscribeStatistics',
  weOpen: 'WeOpen',
  appConnect: 'Connectors',
  appDev: 'AppDev',
  devDocs: 'DevDocs',
  searchHelp: 'Help',
  roma: 'ROMA Lite',
  popularize: 'Popularize',
  guidePage: "Home",
  performanceTest: 'PerformanceTest',
  wecodeRadar: "wecodeRadar",
  wemax: "WeMax",
  developTools: "developTools",
  weGo: "WeGo",
  connectors: "Connectors"
};
